import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider, type RouteObject } from 'react-router';
import { AppShell } from './components/AppShell';
import { useLiveFeeds } from './hooks/useLiveFeeds';
import { canUseApp, useMe } from './hooks/useMe';
import { AdminUsersPage } from './pages/AdminUsers';
import { GuidePage } from './pages/Guide';
import { GuideStoH4Page } from './pages/GuideStoH4';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { NewsPage } from './pages/News';
import { NotFoundPage } from './pages/NotFound';
import { SettingsPage } from './pages/Settings';
import { SignalsPage } from './pages/Signals';
import { SRPage } from './pages/SR';
import { StoH4Page } from './pages/StoH4';
import { SystemPage } from './pages/System';

export const routes: RouteObject[] = [
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <DashboardPage /> },
      { path: '/signals', element: <SignalsPage /> },
      { path: '/sr', element: <SRPage /> },
      { path: '/sto-h4', element: <StoH4Page /> },
      { path: '/guide/sto-h4', element: <GuideStoH4Page /> },
      { path: '/news', element: <NewsPage /> },
      { path: '/system', element: <SystemPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/admin/users', element: <AdminUsersPage /> },
      { path: '/admin/guide', element: <GuidePage /> },
      { path: '/admin/guide/sr', element: <GuidePage system="sr" /> },
      { path: '/login', element: <LoginPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

function LiveFeeds() {
  // WebSockets need an approved session when login is required; do not open them before.
  const me = useMe();
  useLiveFeeds(canUseApp(me.data));
  return null;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: { queries: { staleTime: 2_000, retry: 2, refetchOnWindowFocus: true } },
  });
}

const router = createBrowserRouter(routes);
const queryClient = createQueryClient();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LiveFeeds />
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
